module.exports = __webpack_public_path__ + "img/logo-big.50f5e23d.svg";